import React, { useState, useEffect } from 'react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [currentPath, setCurrentPath] = useState('/');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);

    // Détecte la page actuelle
    setCurrentPath(window.location.pathname);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    {
      label: 'PECB',
      to: 'https://pecb.com',
      isExternal: true,
      isPECB: true
    },
    { label: 'Accueil', to: '/' },
    { label: 'À Propos', to: '/a-propos' },
    { label: 'Nos Services', to: '/nos-services' },
    {
      label: 'Nos Formations',
      // to: 'https://www.cinef-bj.com/formations/nos-domaines/',
      target: '_blank',
      rel: 'noopener noreferrer',
      dropdown: [
        { label: 'Sessions en cours', to: '/sessions-en-cours' },
        { label: 'Nos domaines', to: 'https://www.cinef-bj.com/formations/nos-domaines/', target: '_blank', rel: 'noopener noreferrer' },
        { label: "Certifications CINEF", to: '/certifications-cinef' },
        // { label: 'Certifications', to: '/certifications' },
        { label: 'Formations à distance', to: '/formations-distance' },
        { label: 'Catalogue 2026', to: 'https://www.cinef-bj.com/formations/docs/catalogue_cinef_2026.pdf', target: '_blank', rel: 'noopener noreferrer' },
        { label: 'CINEF EXPERTISE', to: 'https://www.cinef-expertises.com/', target: '_blank', rel: 'noopener noreferrer', isExpertise: true },
      ]
    },

    { label: 'Nos Partenaires', to: '/partenaires' },
    { label: 'Contact', to: '/contact' }
  ];

  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
  };

  const isActivePage = (itemTo) => {
    if (itemTo === '/') {
      return currentPath === '/';
    }
    return currentPath.startsWith(itemTo);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .header-wrapper {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .header {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1000;
          background: #198754;
          backdrop-filter: blur(10px);
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        }

        .header.scrolled {
          background: rgba(255, 255, 255, 0.98);
          backdrop-filter: blur(15px);
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        }

        .header-container {
          max-width: 1320px;
          margin: 0 auto;
          padding: 0 28px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 95px;
          transition: height 0.4s ease;
        }

        .header.scrolled .header-container {
          height: 85px;
        }

        /* Logo sans conteneur blanc */
        .logo-container {
          display: flex;
          align-items: center;
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          margin-right: 20px;
        }

        .logo-container:hover {
          transform: translateY(-3px) scale(1.02);
        }

        .logo {
          display: flex;
          align-items: center;
          gap: 12px;
          text-decoration: none;
        }

        .logo-image {
          height: 58px;
          width: auto;
          transition: all 0.4s ease;
        }

        .header.scrolled .logo-image {
          height: 54px;
        }

        /* Logo blanc visible sur fond vert */
        .logo-white {
          display: block;
        }

        .header.scrolled .logo-white {
          display: none;
        }

        /* Logo coloré visible sur fond blanc */
        .logo-color {
          display: none;
        }

        .header.scrolled .logo-color {
          display: block;
        }

        .nav {
          display: flex;
          align-items: center;
          gap: 2px;
          flex: 1;
          justify-content: center;
          flex-wrap: nowrap;
        }

        /* Style spécial pour PECB */
        .nav-link.pecb {
          background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
          color: white !important;
          font-weight: 700;
          padding: 11px 18px;
          border-radius: 10px;
          box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
          margin-right: 6px;
          position: relative;
          overflow: hidden;
          white-space: nowrap;
        }

        .nav-link.pecb::before {
          content: '';
          margin-right: 6px;
          font-size: 14px;
        }

        .nav-link.pecb::after {
          display: none !important;
        }

        .nav-link.pecb:hover {
          background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
          transform: translateY(-3px);
          box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
        }

        .header.scrolled .nav-link.pecb {
          box-shadow: 0 3px 10px rgba(220, 53, 69, 0.25);
        }

        .nav-link {
          position: relative;
          padding: 11px 16px;
          color: rgba(255, 255, 255, 0.95);
          text-decoration: none;
          font-size: 15px;
          font-weight: 600;
          border-radius: 10px;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
          display: block;
          white-space: nowrap;
        }

        .header.scrolled .nav-link {
          color: #4a5568;
        }

        /* Indicateur de page active */
        .nav-link.active-page {
          background: rgba(255, 255, 255, 0.25);
          color: white;
          font-weight: 700;
        }

        .header.scrolled .nav-link.active-page {
          background: rgba(25, 135, 84, 0.15);
          color: #198754;
        }

        .nav-link.active-page::after {
          transform: scaleX(1) !important;
        }

        .nav-link:hover {
          color: #ffc107;
          background: rgba(255, 255, 255, 0.15);
          transform: translateY(-2px);
        }

        .header.scrolled .nav-link:hover {
          color: #198754;
          background: rgba(25, 135, 84, 0.1);
        }

        .nav-link::after {
          content: '';
          position: absolute;
          bottom: 6px;
          left: 16px;
          right: 16px;
          height: 3px;
          transform: scaleX(0);
          transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          border-radius: 3px;
        }

        .nav-link:hover::after {
          transform: scaleX(1);
        }

        .nav-link.has-dropdown::before {
          content: '▾';
          margin-left: 6px;
          font-size: 12px;
          transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          display: inline-block;
        }

        .nav-link.has-dropdown.active::before {
          transform: rotate(180deg);
        }

        .dropdown {
          position: absolute;
          top: calc(100% + 10px);
          left: 0;
          background: white;
          border-radius: 14px;
          box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
          padding: 10px;
          min-width: 250px;
          opacity: 0;
          visibility: hidden;
          transform: translateY(-10px) scale(0.95);
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          border: 1px solid rgba(0, 0, 0, 0.06);
        }

        .nav-item {
          position: relative;
        }

        .nav-item:hover .dropdown,
        .nav-item.active .dropdown {
          opacity: 1;
          visibility: visible;
          transform: translateY(0) scale(1);
        }

        .dropdown-link {
          display: block;
          padding: 13px 18px;
          color: #4a5568;
          text-decoration: none;
          font-size: 14.5px;
          font-weight: 500;
          border-radius: 10px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .dropdown-link:hover {
          background: rgba(25, 135, 84, 0.12);
          color: #198754;
          transform: translateX(6px);
        }

        /* Style spécial pour CINEF EXPERTISE dans le dropdown */
        .dropdown-link.expertise {
          background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
          color: white !important;
          font-weight: 700;
          box-shadow: 0 3px 10px rgba(220, 53, 69, 0.25);
          margin-top: 8px;
          position: relative;
        }

        .dropdown-link.expertise::before {
          content: '';
          margin-right: 8px;
        }

        .dropdown-link.expertise:hover {
          background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
          color: white !important;
          box-shadow: 0 5px 15px rgba(220, 53, 69, 0.35);
          transform: translateX(6px) scale(1.02);
        }

        .header-actions {
          display: flex;
          align-items: center;
          gap: 12px;
          flex-shrink: 0;
        }

        .btn {
          padding: 11px 20px;
          border: none;
          border-radius: 11px;
          font-size: 14.5px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          white-space: nowrap;
        }

        .btn-secondary {
          background: transparent;
          color: white;
          border: 2.5px solid white;
        }

        .header.scrolled .btn-secondary {
          color: #198754;
          border-color: #198754;
        }

        .btn-secondary:hover {
          background: white;
          color: #198754;
          transform: translateY(-2px) scale(1.05);
          box-shadow: 0 6px 20px rgba(255, 255, 255, 0.3);
        }

        .header.scrolled .btn-secondary:hover {
          background: #198754;
          color: white;
          border-color: #198754;
          box-shadow: 0 6px 20px rgba(25, 135, 84, 0.3);
        }

        .btn-primary {
          background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%);
          color: white;
          box-shadow: 0 4px 14px rgba(255, 193, 7, 0.35);
        }

        .btn-primary:hover {
          transform: translateY(-2px) scale(1.05);
          box-shadow: 0 6px 22px rgba(255, 193, 7, 0.5);
        }

        .mobile-menu-btn {
          display: none;
          flex-direction: column;
          gap: 5px;
          background: white;
          border: none;
          cursor: pointer;
          padding: 11px;
          border-radius: 10px;
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
          transition: all 0.3s ease;
        }

        .mobile-menu-btn:hover {
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.18);
          transform: scale(1.05);
        }

        .mobile-menu-btn span {
          width: 26px;
          height: 2.5px;
          background: #198754;
          border-radius: 2px;
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .mobile-menu-btn.active span:nth-child(1) {
          transform: rotate(45deg) translate(6px, 6px);
        }

        .mobile-menu-btn.active span:nth-child(2) {
          opacity: 0;
        }

        .mobile-menu-btn.active span:nth-child(3) {
          transform: rotate(-45deg) translate(6px, -6px);
        }

        .mobile-menu {
          position: fixed;
          top: 95px;
          left: 0;
          right: 0;
          background: white;
          border-top: 1px solid rgba(0, 0, 0, 0.06);
          padding: 26px;
          transform: translateY(-100%);
          opacity: 0;
          visibility: hidden;
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          box-shadow: 0 12px 48px rgba(0, 0, 0, 0.12);
          max-height: calc(100vh - 95px);
          overflow-y: auto;
        }

        .header.scrolled .mobile-menu {
          top: 85px;
          max-height: calc(100vh - 85px);
        }

        .mobile-menu.active {
          transform: translateY(0);
          opacity: 1;
          visibility: visible;
        }

        /* PECB mobile */
        .mobile-nav-link.pecb {
          background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
          color: white !important;
          font-weight: 700;
          margin-bottom: 12px;
          box-shadow: 0 3px 10px rgba(220, 53, 69, 0.25);
        }

        .mobile-nav-link.pecb::before {
          
        }

        .mobile-nav-link {
          display: block;
          padding: 15px 18px;
          color: #4a5568;
          text-decoration: none;
          font-size: 16px;
          font-weight: 600;
          border-radius: 10px;
          transition: all 0.3s ease;
        }

        .mobile-nav-link.active-page {
          background: rgba(25, 135, 84, 0.12);
          color: #198754;
          font-weight: 700;
        }

        .mobile-nav-link:hover {
          background: rgba(25, 135, 84, 0.1);
          color: #198754;
          transform: translateX(4px);
        }

        .mobile-dropdown {
          padding-left: 22px;
          margin-top: 10px;
          display: none;
          animation: slideDown 0.3s ease;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .mobile-dropdown.active {
          display: block;
        }

        .mobile-dropdown-link {
          display: block;
          padding: 11px 18px;
          color: #718096;
          text-decoration: none;
          font-size: 14.5px;
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .mobile-dropdown-link:hover {
          background: rgba(25, 135, 84, 0.08);
          color: #198754;
          transform: translateX(4px);
        }

        /* Style spécial pour CINEF EXPERTISE dans le mobile dropdown */
        .mobile-dropdown-link.expertise {
          background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
          color: white !important;
          font-weight: 700;
          box-shadow: 0 3px 10px rgba(220, 53, 69, 0.25);
          margin-top: 8px;
        }

        .mobile-dropdown-link.expertise::before {
          content: '🎯';
          margin-right: 8px;
        }

        .mobile-dropdown-link.expertise:hover {
          background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
          color: white !important;
          box-shadow: 0 5px 15px rgba(220, 53, 69, 0.35);
          transform: translateX(4px) scale(1.02);
        }
          
.header:not(.scrolled) .btn-elearning {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  box-shadow: 0 4px 14px rgba(220, 53, 69, 0.35);
}

.header:not(.scrolled) .btn-elearning:hover {
  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 6px 22px rgba(220, 53, 69, 0.5);
}



        .mobile-actions {
          margin-top: 26px;
          padding-top: 26px;
          border-top: 1px solid rgba(0, 0, 0, 0.06);
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        @media (max-width: 1200px) {
          .nav {
            gap: 1px;
          }

          .nav-link {
            padding: 11px 14px;
            font-size: 14.5px;
          }

          .nav-link.pecb {
            padding: 11px 16px;
            margin-right: 4px;
          }

          .btn {
            padding: 11px 18px;
            font-size: 14px;
          }
        }

        @media (max-width: 1100px) {
          .nav, .header-actions {
            display: none;
          }

          .mobile-menu-btn {
            display: flex;
          }

          .logo-container {
            margin-right: 10px;
          }
        }

        @media (max-width: 640px) {
          .header-container {
            padding: 0 18px;
            height: 85px;
          }

          .header.scrolled .header-container {
            height: 78px;
          }

          .logo-container {
            margin-right: 8px;
          }

          .logo-image {
            height: 50px;
          }

          .header.scrolled .logo-image {
            height: 46px;
          }

          .mobile-menu {
            top: 85px;
            max-height: calc(100vh - 85px);
          }

          .header.scrolled .mobile-menu {
            top: 78px;
            max-height: calc(100vh - 78px);
          }
        }
      `}</style>

      <div className="header-wrapper">
        <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
          <div className="header-container">
            {/* Logo avec deux versions */}
            <div className="logo-container">
              <a href="/" className="logo">
                {/* Logo blanc pour fond vert */}
                <img
                  src="../assets/images/Logo2.png"
                  alt="CINEF Logo"
                  className="logo-image logo-white"
                />
                {/* Logo coloré pour fond blanc */}
                <img
                  src="../assets/images/Logo_CINEF.png"
                  alt="CINEF Logo"
                  className="logo-image logo-color"
                />
              </a>
            </div>

            {/* Desktop Navigation */}
            <nav className="nav">
              {menuItems.map((item, index) => (
                <div
                  key={index}
                  className="nav-item"
                  onMouseEnter={() => item.dropdown && setActiveDropdown(index)}
                  onMouseLeave={() => setActiveDropdown(null)}
                >
                  <a
                    href={item.to}
                    className={`nav-link ${item.dropdown ? 'has-dropdown' : ''} ${activeDropdown === index ? 'active' : ''} ${item.isPECB ? 'pecb' : ''} ${!item.isPECB && !item.isExternal && isActivePage(item.to) ? 'active-page' : ''}`}
                    target={item.isExternal ? '_blank' : '_self'}
                    rel={item.isExternal ? 'noopener noreferrer' : ''}
                  >
                    {item.label}
                  </a>
                  {item.dropdown && (
                    <div className="dropdown">
                      {item.dropdown.map((dropItem, dropIndex) => (
                        <a
                          key={dropIndex}
                          href={dropItem.to}
                          className={`dropdown-link ${dropItem.isExpertise ? 'expertise' : ''}`}
                          target={dropItem.target}
                          rel={dropItem.rel}
                        >
                          {dropItem.label}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </nav>

            {/* Desktop Actions */}
            <div className="header-actions">
              <a href="https://cinef-formations.trainercentralsite.com/#/allcourses" className="btn btn-secondary btn-elearning">
                E-Learning
              </a>
              <a href="/login" className="btn btn-primary">
                Connexion
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>

          {/* Mobile Menu */}
          <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            {menuItems.map((item, index) => (
              <div key={index}>
                <a
                  href={item.to}
                  className={`mobile-nav-link ${item.isPECB ? 'pecb' : ''} ${!item.isPECB && !item.isExternal && isActivePage(item.to) ? 'active-page' : ''}`}
                  target={item.isExternal ? '_blank' : '_self'}
                  rel={item.isExternal ? 'noopener noreferrer' : ''}
                  onClick={(e) => {
                    if (item.dropdown) {
                      e.preventDefault();
                      setActiveDropdown(activeDropdown === index ? null : index);
                    } else {
                      handleNavClick();
                    }
                  }}
                >
                  {item.label}
                </a>
                {item.dropdown && (
                  <div className={`mobile-dropdown ${activeDropdown === index ? 'active' : ''}`}>
                    {item.dropdown.map((dropItem, dropIndex) => (
                      <a
                        key={dropIndex}
                        href={dropItem.to}
                        className={`mobile-dropdown-link ${dropItem.isExpertise ? 'expertise' : ''}`}
                        target={dropItem.target}
                        rel={dropItem.rel}
                        onClick={handleNavClick}
                      >
                        {dropItem.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <div className="mobile-actions">
              <a href="https://cinef-formations.trainercentralsite.com/#/allcourses" className="btn btn-secondary" style={{ width: '100%', justifyContent: 'center' }}>
                E-Learning
              </a>
              <a href="/login" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
                Connexion
              </a>
            </div>
          </div>
        </header>
      </div>
    </>
  );
};

export default Header;